// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__3_mx4","name":"NavBar_name__k8PQB"};